export const defaultGermanDateFormat = "dd.MM.yyyy";
export const defaultGermanTimeFormat = "HH:mm";

export const convertDotNetTicksToJSTicks = ticks => {
  if (ticks) {
    try {
      //ticks are in nanotime; convert to microtime
      var ticksToMicrotime = 10000;
      //ticks are recorded from 1/1/1; get microtime difference from 1/1/1/ to 1/1/1970
      var epochMicrotimeDiff = 621355968000000000;
      return (ticks - epochMicrotimeDiff) / ticksToMicrotime;
    } catch (err) {}
  }
  return null;
};

export const convertJSTicksToDotNetTicks = ticks => {
  if (ticks) {
    try {
      //ticks are in nanotime; convert to microtime
      var ticksToMicrotime = 10000;
      //ticks are recorded from 1/1/1; get microtime difference from 1/1/1/ to 1/1/1970
      var epochMicrotimeDiff = 621355968000000000;
      return ticks * ticksToMicrotime + epochMicrotimeDiff;
    } catch (err) {}
  }
  return null;
};
